{
  "Agent ready": "Agent-klar",
  "Agent state": "Agent-status",
  "Asking question": "Stiller spørgsmål",
  "Assign to AI": "Tildel til AI",
  "Automation environment ID": "Automatiseringsmiljø-id",
  "Automation links": "Automatiseringslinks",
  "Automation setup: %{status}": "Automatiseringsopsætning: %{status}",
  "Automation status": "Automatiseringsstatus",
  "Blocked": "Blokeret",
  "Claimed": "Reserveret",
  "Claimed by": "Reserveret af",
  "Coding": "Koder",
  "Complete": "Fuldført",
  "Disabled": "Deaktiveret",
  "Enable AI task assignment": "Aktivér AI-opgavetildeling",
  "Environment required": "Miljø påkrævet",
  "Instance": "Instans",
  "In review": "Til gennemgang",
  "Logs": "Logge",
  "Mark agent-ready": "Markér som agent-klar",
  "Not under automation": "Ikke under automatisering",
  "Queued": "I kø",
  "Run": "Kørsel",
  "The task was assigned to AI": "Opgaven blev tildelt til AI",
  "TensorBuzz bot": "TensorBuzz-bot",
  "TensorBuzz command": "TensorBuzz-kommando",
  "Unknown": "Ukendt",
  "Verifying": "Verificerer",
  "Waiting for reply": "Afventer svar",
  "A name is required": "Et navn er påkrævet",
  "Auth tokens": "Auth-tokens",
  "Auth tokens let an AI bot or app act on your behalf through the API. Treat them like passwords — anyone with a token has your access until you revoke it.": "Auth-tokens lader en AI-bot eller app handle på dine vegne via API'et. Behandl dem som adgangskoder — enhver med et token har din adgang, indtil du tilbagekalder det.",
  "Copy token": "Kopiér token",
  "Copy your token now. For your security, it will not be shown again.": "Kopiér dit token nu. Af sikkerhedshensyn vises det ikke igen.",
  "Could not load auth token": "Kunne ikke indlæse auth-token",
  "Could not load auth tokens": "Kunne ikke indlæse auth-tokens",
  "Created %{date}": "Oprettet %{date}",
  "Done": "Færdig",
  "Generate auth token": "Generér auth-token",
  "Generate new token": "Generér nyt token",
  "Generate token": "Generér token",
  "Generate tokens an AI bot or app can use to act on your behalf through the API.": "Generér tokens, som en AI-bot eller app kan bruge til at handle på dine vegne via API'et.",
  "Generating...": "Genererer...",
  "Last used %{date}": "Sidst brugt %{date}",
  "Manage auth tokens": "Administrér auth-tokens",
  "Never used": "Aldrig brugt",
  "Rename": "Omdøb",
  "Rename auth token": "Omdøb auth-token",
  "Revoke": "Tilbagekald",
  "Revoke this auth token? Apps using it will stop working immediately.": "Tilbagekald dette auth-token? Apps, der bruger det, holder op med at virke med det samme.",
  "Select the token above to copy it": "Markér tokenet ovenfor for at kopiere det",
  "The auth token was created": "Auth-tokenet blev oprettet",
  "The auth token was renamed": "Auth-tokenet blev omdøbt",
  "The auth token was revoked": "Auth-tokenet blev tilbagekaldt",
  "Token copied to clipboard": "Token kopieret til udklipsholderen",
  "Token name": "Tokennavn",
  "You have no auth tokens yet": "Du har endnu ingen auth-tokens",
  "Account not found": "Kontoen blev ikke fundet",
  "Account": "Konto",
  "Accounts": "Konti",
  "Awesome Tasks": "Awesome Tasks",
  "Dashboard": "Oversigt",
  "Edit profile": "Rediger profil",
  "Appearance": "Udseende",
  "Invoicing": "Fakturering",
  "Language": "Sprog",
  "Time": "Tid",
  "Work": "Arbejde",
  "Personalize the app to your preferences": "Personliggør appen efter dine præferencer",
  "Profile": "Profil",
  "Settings": "Indstillinger",
  "Settings saved": "Indstillinger gemt",
  "Sign in to manage your settings": "Log ind for at administrere dine indstillinger",
  "Back to home": "Tilbage til forsiden",
  "Confirm": "Bekræft",
  "Dark theme": "Mørkt tema",
  "Light theme": "Lyst tema",
  "Page not found": "Siden blev ikke fundet",
  "The page you were looking for does not exist or has moved.": "Den side, du leder efter, eksisterer ikke eller er blevet flyttet.",
  "Account created": "Konto oprettet",
  "Already have an account? Sign in": "Har du allerede en konto? Log ind",
  "Back to sign in": "Tilbage til login",
  "Create account": "Opret konto",
  "Creating...": "Opretter...",
  "Don't have an account? Sign up": "Har du ikke en konto? Opret en",
  "Password must be at least 6 characters": "Adgangskode skal være mindst 6 tegn",
  "Sign up": "Opret",
  "Sign up failed": "Oprettelse mislykkedes",
  "Sign up with your email and a password": "Opret med din e-mail og en adgangskode",
  "Email and password are required": "E-mail og adgangskode er påkrævet",
  "Email is required": "E-mail er påkrævet",
  "Enter your email and password to continue": "Indtast e-mail og adgangskode for at fortsætte",
  "Enter your email and we will send you a reset link": "Indtast din e-mail, så sender vi dig et nulstillingslink",
  "Forgot password": "Glemt adgangskode",
  "Forgot password?": "Glemt adgangskode?",
  "Password reset email sent": "E-mail med nulstilling sendt",
  "Password reset request failed": "Anmodning om nulstilling fejlede",
  "Send reset link": "Send nulstillingslink",
  "Sending...": "Sender...",
  "Password": "Adgangskode",
  "Primary organization": "Primær organisation",
  "Sign in": "Log ind",
  "Sign in failed": "Login mislykkedes",
  "Signed in": "Logget ind",
  "Signing in...": "Logger ind...",
  "Sign out": "Log ud",
  "Signed out": "Logget ud",
  "Signing out...": "Logger ud...",
  "Created": "Oprettet",
  "Creditor": "Kreditor",
  "Customer": "Kunde",
  "Edit": "Rediger",
  "Edit account": "Rediger konto",
  "Email": "E-mail",
  "First name": "Fornavn",
  "Actions": "Handlinger",
  "Add timelog": "Tilføj tidslog",
  "Apply": "Anvend",
  "Assigned users": "Tildelte brugere",
  "Assign user": "Tildel bruger",
  "Attach file": "Vedhæft fil",
  "Comment": "Kommentar",
  "Close": "Luk",
  "Choose a task type.": "Vælg en opgavetype.",
  "Date": "Dato",
  "Column Name": "Kolonnenavn",
  "Create": "Opret",
  "Create New Task": "Opret ny opgave",
  "Creating...": "Opretter...",
  "Failed to load autoassigned users": "Kunne ikke indlæse auto-tildelte brugere",
  "Failed to load board": "Kunne ikke indlæse tavle",
  "Failed to load members": "Kunne ikke indlæse medlemmer",
  "Failed to load organization": "Kunne ikke indlæse organisation",
  "Failed to load project": "Kunne ikke indlæse projekt",
  "Failed to load task types": "Kunne ikke indlæse opgavetyper",
  "Failed to load tasks": "Kunne ikke indlæse opgaver",
  "Edit assignment": "Rediger tildeling",
  "Add to Board": "Føj til tavle",
  "Board": "Tavle",
  "Board placement": "Tavleplacering",
  "Board not found.": "Tavlen blev ikke fundet.",
  "Boards": "Tavler",
  "Adding Board...": "Tilføjer tavle...",
  "Column: %{columnName}": "Kolonne: %{columnName}",
  "Loading Boards...": "Indlæser tavler...",
  "Remove Board placement": "Fjern tavleplacering",
  "Remove from Board": "Fjern fra tavle",
  "Remove": "Fjern",
  "Remove this task from %{boardName}?": "Fjern denne opgave fra %{boardName}?",
  "Removing...": "Fjerner...",
  "Offline": "Offline",
  "Pending": "Afventer",
  "Syncing": "Synkroniserer",
  "Syncing…": "Synkroniserer…",
  "Failed": "Mislykkedes",
  "Conflicted": "Konflikt",
  "Retry": "Prøv igen",
  "Search projects and Boards...": "Søg efter projekter og tavler...",
  "This task is not on any Boards.": "Denne opgave er ikke på nogen tavler.",
  "Edit invoice group": "Rediger faktureringsgruppe",
  "Details": "Detaljer",
  "Edit timelog": "Rediger tidslog",
  "File": "Fil",
  "File not found": "Filen blev ikke fundet",
  "Open file": "Åbn fil",
  "Resource": "Ressource",
  "Uploaded by": "Uploadet af",
  "Edit project": "Rediger projekt",
  "Edit task": "Rediger opgave",
  "Edit user": "Rediger bruger",
  "Autoassigned users": "Auto-tildelte brugere",
  "Invoice group not found": "Faktureringsgruppen blev ikke fundet",
  "Invoice groups": "Faktureringsgrupper",
  "Invoices": "Fakturaer",
  "Loading...": "Indlæser...",
  "Name": "Navn",
  "No invoice groups found": "Ingen faktureringsgrupper fundet",
  "No invoices were linked to this invoice group": "Ingen fakturaer var tilknyttet denne faktureringsgruppe",
  "No assigned users": "Ingen tildelte brugere",
  "No users assigned to this task": "Ingen brugere er tildelt denne opgave",
  "User added to task": "Bruger tilføjet til opgaven",
  "User removed from task": "Bruger fjernet fra opgaven",
  "You": "Dig",
  "Cancel": "Annuller",
  "Delete": "Slet",
  "Delete file": "Slet fil",
  "No files found": "Ingen filer fundet",
  "No invoices found": "Ingen fakturaer fundet",
  "New account": "Ny konto",
  "New invoice group": "Ny faktureringsgruppe",
  "New project": "Nyt projekt",
  "Project": "Projekt",
  "Project not found": "Projektet blev ikke fundet",
  "Priority": "Prioritet",
  "New task": "Ny opgave",
  "New timelog": "Ny tidslog",
  "New Column": "Ny kolonne",
  "New user": "Ny bruger",
  "No accounts found": "Ingen konti fundet",
  "Not signed in": "Du skal logge ind for at fortsætte",
  "No tasks in this column": "Ingen opgaver i denne kolonne",
  "No matching tasks found": "Ingen matchende opgaver fundet",
  "State": "Status",
  "Save": "Gem",
  "Search": "Søg",
  "All states": "Alle statusser",
  "All creditors": "Alle kreditorer",
  "All debitors": "Alle debitorer",
  "All invoice types": "Alle fakturatyper",
  "Clear filters": "Ryd filtre",
  "Debitor": "Debitor",
  "Refresh": "Opdater",
  "Sort": "Sortering",
  "Task not found": "Opgaven blev ikke fundet",
  "Time": "Tid",
  "Timelog": "Tidslog",
  "Timelog deleted": "Tidslog slettet",
  "Timelog not found": "Tidsloggen blev ikke fundet",
  "Time transport": "Transporttid",
  "Time Logs Dashboard": "Tidslogs-dashboard",
  "More filters": "Flere filtre",
  "Saving...": "Gemmer...",
  "Search accounts...": "Søg konti...",
  "Invoicing status": "Faktureringsstatus",
  "Invoiced only": "Kun fakturerede",
  "No timelogs found": "Ingen tidslogs fundet",
  "No timelogs found for this period.": "Ingen tidslogs fundet i denne periode.",
  "No previous period": "Ingen forrige periode",
  "Uninvoiced only": "Kun ikke-fakturerede",
  "Task": "Opgave",
  "Task details": "Opgavedetaljer",
  "Task ID": "Opgave-ID",
  "Task Type": "Opgavetype",
  "Task not found on this board.": "Opgaven blev ikke fundet på denne tavle.",
  "Timelogs": "Tidslogs",
  "The assignment was saved": "Tildelingen blev gemt",
  "The file was deleted": "Filen blev slettet",
  "The timelog was saved": "Tidsloggen blev gemt",
  "Uploaded files": "Uploadede filer",
  "Time (minutes)": "Tid (minutter)",
  "Time transport (minutes)": "Transporttid (minutter)",
  "Transport length": "Transportlængde",
  "Transport length (km)": "Transportlængde (km)",
  "Untitled column": "Kolonne uden navn",
  "Untitled task": "Opgave uden navn",
  "Last name": "Efternavn",
  "Updated": "Opdateret",
  "User": "Bruger",
  "User not found": "Brugeren blev ikke fundet",
  "Organization": "Organisation",
  "Organization not found": "Organisationen blev ikke fundet",
  "Delete organization": "Slet organisation",
  "Payment info": "Betalingsoplysninger",
  "Delivery address": "Leveringsadresse",
  "Delivery zip code": "Leveringspostnummer",
  "Delivery city": "Leveringsby",
  "Delivery country": "Leveringsland",
  "Invoice address": "Faktureringsadresse",
  "Invoice zip code": "Faktureringspostnummer",
  "Invoice city": "Faktureringsby",
  "Invoice country": "Faktureringsland",
  "VAT no": "CVR-nummer",
  "Edit organization": "Rediger organisation",
  "New organization": "Ny organisation",
  "The organization was deleted": "Organisationen blev slettet",
  "The organization was saved": "Organisationen blev gemt",
  "Amount": "Beløb",
  "Amount currency": "Valuta",
  "Edit invoice line": "Rediger fakturalinje",
  "Invoice line not found": "Fakturalinje ikke fundet",
  "New invoice line": "Ny fakturalinje",
  "Quantity": "Antal",
  "The invoice line was saved": "Fakturalinjen blev gemt",
  "Title": "Titel",
  "Edit comment": "Rediger kommentar",
  "New comment": "Ny kommentar",
  "The comment was saved": "Kommentaren blev gemt",
  "Comment not found": "Kommentaren blev ikke fundet",
  "Changed the task status to %{state}": "Ændrede opgavens status til %{state}",
  "Comments": "Kommentarer",
  "No comments found": "Ingen kommentarer fundet",
  "Add invoice line": "Tilføj fakturalinje",
  "Amount total": "Beløb i alt",
  "Amount VAT": "Moms",
  "Amounts": "Beløb",
  "Finish": "Færdiggør",
  "ID": "ID",
  "Invoice %{number}": "Faktura %{number}",
  "Invoice lines": "Fakturalinjer",
  "Invoice no": "Fakturanummer",
  "Invoice not found": "Faktura ikke fundet",
  "Invoice type": "Fakturatype",
  "Manage": "Administrer",
  "More": "Mere",
  "Mine": "Mine",
  "No": "Nej",
  "No invoice groups": "Ingen faktureringsgrupper",
  "No invoice lines": "Ingen fakturalinjer",
  "No VAT": "Ingen moms",
  "Payment date": "Betalingsdato",
  "Register as paid": "Registrer som betalt",
  "Register as sent": "Registrer som sendt",
  "All": "Alle",
  "Load more": "Indlæs flere",
  "%{count} active members": "%{count} aktive medlemmer",
  "%{count} assigned": "%{count} tildelt",
  "%{count} comments": "%{count} kommentarer",
  "%{count} projects": "%{count} projekter",
  "%{count} timelogs": "%{count} tidslogs",
  "Last activity: %{date}": "Senest aktiv: %{date}",
  "Manage organizations, customers and creditors": "Håndtér organisationer, kunder og kreditorer",
  "No activity yet": "Ingen aktivitet endnu",
  "No organizations found": "Ingen organisationer fundet",
  "Organizations": "Organisationer",
  "Search organizations by name...": "Søg organisationer efter navn...",
  "Search organizations...": "Søg organisationer...",
  "Date from": "Dato fra",
  "Date range": "Datointerval",
  "Date to": "Dato til",
  "Delete Column": "Slet kolonne",
  "Delete Task": "Slet opgave",
  "Delete the column %{name}?": "Slet kolonnen %{name}?",
  "Delete this task?": "Slet denne opgave?",
  "Delete this timelog?": "Slet denne tidslog?",
  "Manage and track team billable hours": "Administrer og følg teamets fakturerbare timer",
  "Loading dashboard...": "Indlæser dashboard...",
  "Search by comment...": "Søg efter kommentar...",
  "No users found": "Ingen brugere fundet",
  "No organization": "Ingen organisation",
  "Search users...": "Søg brugere...",
  "Users": "Brugere",
  "After tax (40%)": "Efter skat (40%)",
  "Distance": "Afstand",
  "Due soon": "Snart forfalden",
  "Earned": "Indtjent",
  "Entries": "Registreringer",
  "Enter a duration like 1h 5m, 30s or 1.5": "Angiv en varighed som 1t 5m, 30s eller 1,5",
  "1h 5m, 30s or 1.5": "1t 5m, 30s eller 1,5",
  "Hours": "Timer",
  "h": "t",
  "Invoiced": "Faktureret",
  "Billing progress": "Faktureringsfremdrift",
  "Estimated earnings": "Estimeret indtjening",
  "Invoiced %{invoiced} of %{total}%{currency}": "Faktureret %{invoiced} af %{total}%{currency}",
  "Internal": "Intern",
  "Overview": "Oversigt",
  "Transport": "Transport",
  "Transport earned": "Transportindtjening",
  "Total earned": "Indtjent i alt",
  "Rate": "Sats",
  "Status": "Status",
  "Unknown user": "Ukendt bruger",
  "Unknown date": "Ukendt dato",
  "Untitled entry": "Unavngivet registrering",
  "%{amount} %{currency}": "%{amount} %{currency}",
  "%{amount} %{currency}/h": "%{amount} %{currency}/t",
  "%{date} · %{user}": "%{date} · %{user}",
  "Active": "Aktiv",
  "Finished": "Færdig",
  "Inactive": "Inaktiv",
  "Browse, search and manage projects": "Gennemse, søg og håndtér projekter",
  "Delete project: %{name}?": "Slet projekt: %{name}?",
  "Members": "Medlemmer",
  "No autoassigned users found": "Ingen auto-tildelte brugere fundet",
  "No members found": "Ingen medlemmer fundet",
  "No projects found": "Ingen projekter fundet",
  "No projects yet.": "Ingen projekter endnu.",
  "Project deleted": "Projekt slettet",
  "Projects": "Projekter",
  "Search projects by name...": "Søg projekter efter navn...",
  "Search projects...": "Søg projekter...",
  "This will also remove the project's boards, tasks, task types and user assignments.": "Dette fjerner også projektets boards, opgaver, opgavetyper og brugertildelinger.",
  "Closed": "Lukket",
  "No board column": "Ingen tavlekolonne",
  "No task type": "Ingen opgavetype",
  "No tasks found": "Ingen opgaver fundet",
  "Unnamed project": "Unavngivet projekt",
  "Unnamed task": "Unavngivet opgave",
  "Unnamed task type": "Unavngivet opgavetype",
  "Open": "Åben",
  "Loading board...": "Indlæser tavle...",
  "Column": "Kolonne",
  "Column actions": "Kolonnehandlinger",
  "Status color": "Statusfarve",
  "Add task": "Tilføj opgave",
  "Edit Column": "Rediger kolonne",
  "Issue title": "Opgavetitel",
  "Please enter a column name.": "Indtast et kolonnenavn.",
  "Please enter a title.": "Indtast en titel.",
  "Add context or acceptance details...": "Tilføj kontekst eller acceptkriterier...",
  "Description": "Beskrivelse",
  "e.g. Backlog, In Review": "f.eks. Backlog, Klar til review",
  "Confirm delete": "Bekræft sletning",
  "Credit": "Kredit",
  "Debit": "Debet",
  "Deleting...": "Sletter...",
  "Draft": "Kladde",
  "Edit invoice %{id}": "Rediger faktura %{id}",
  "Enter details": "Indtast detaljer",
  "Highest amount": "Højeste beløb",
  "Invoice number A-Z": "Fakturanummer A-Z",
  "Invoice number Z-A": "Fakturanummer Z-A",
  "Lowest amount": "Laveste beløb",
  "New invoice": "Ny faktura",
  "Newest first": "Nyeste først",
  "Name A-Z": "Navn A-Å",
  "Name Z-A": "Navn Å-A",
  "Oldest first": "Ældste først",
  "Open, confirmed, and waiting": "Åben, bekræftet og afventer",
  "Paid": "Betalt",
  "Purchase": "Køb",
  "Search invoices...": "Søg fakturaer...",
  "Sent": "Sendt",
  "Show": "Vis",
  "State A-Z": "Status A-Z",
  "Type": "Type",
  "Type A-Z": "Type A-Z",
  "Search tasks...": "Søg opgaver...",
  "Search tasks by name or description...": "Søg opgaver efter navn eller beskrivelse...",
  "Task actions": "Opgavehandlinger",
  "Tasks": "Opgaver",
  "Task deleted": "Opgave slettet",
  "Delete task: %{name}?": "Slet opgave: %{name}?",
  "Track and manage tasks across projects": "Spor og håndtér opgaver på tværs af projekter",
  "All projects": "Alle projekter",
  "All users": "Alle brugere",
  "Any": "Alle",
  "Daily timelogs aggregated for the selected range": "Daglige tidslogs samlet for valgt periode",
  "Export CSV": "Eksportér CSV",
  "Exporting...": "Eksporterer...",
  "Exported %{count} timelogs": "Eksporterede %{count} tidslogs",
  "Filter, export and bulk-invoice tracked time": "Filtrér, eksportér og masse-fakturér registreret tid",
  "Mark all invoiced": "Marker alle som faktureret",
  "Mark all matching timelogs as invoiced?": "Marker alle matchende tidslogs som faktureret?",
  "Marked %{count} timelogs as invoiced": "Markerede %{count} tidslogs som faktureret",
  "Marking...": "Markerer...",
  "Not invoiced": "Ikke faktureret",
  "Total hours": "Samlede timer",
  "Transport hours": "Transporttimer",
  "Invoiced / not invoiced": "Faktureret / ikke faktureret",
  "Currency": "Valuta",
  "Edit invoice": "Rediger faktura",
  "Work status": "Arbejdsstatus",
  "%{percent} vs %{range}": "%{percent} mod %{range}",
  "%{from} - %{to}": "%{from} - %{to}",
  "Yes": "Ja",
  "Choose file": "Vælg fil",
  "No file chosen": "Ingen fil valgt",
  "A file upload is required": "En filupload er påkrævet",
  "Could not load the form": "Kunne ikke indlæse formularen",
  "Could not save the bill": "Regningen kunne ikke gemmes",
  "Could not save the file": "Kunne ikke gemme filen",
  "File uploads are only supported on the web": "Filupload understøttes kun på web",
  "New file": "Ny fil",
  "New bill": "Ny regning",
  "New creditor": "Ny kreditor",
  "No creditors found": "Ingen kreditorer fundet",
  "Select creditor": "Vælg kreditor",
  "Uploaded file": "Uploadet fil",
  "Add uninvoiced timelogs": "Tilføj ufakturerede tidslogs",
  "No uploaded files": "Ingen uploadede filer",
  "Delete invoice": "Slet faktura",
  "Delete invoice line": "Slet fakturalinje",
  "Delete this invoice?": "Slet denne faktura?",
  "Delete this invoice line?": "Slet denne fakturalinje?",
  "Added %{count} uninvoiced timelogs": "Tilføjede %{count} ufakturerede tidslogs",
  "Invoice finished": "Fakturaen blev færdiggjort",
  "Invoice registered as sent": "Fakturaen blev registreret som sendt",
  "Invoice registered as paid": "Fakturaen blev registreret som betalt",
  "PDF": "PDF",
  "The invoice line was deleted": "Fakturalinjen blev slettet",
  "Deactivated": "Deaktiveret",
  "Deadline at": "Deadline",
  "Delete this user?": "Slet denne bruger?",
  "Delete user": "Slet bruger",
  "Invited": "Inviteret",
  "Last login: %{date}": "Seneste login: %{date}",
  "Member": "Medlem",
  "Never": "Aldrig",
  "The user was deleted": "Brugeren blev slettet",
  "Add": "Tilføj",
  "Add daily work": "Tilføj dagligt arbejde",
  "Add new user role": "Tilføj ny brugerrolle",
  "Add user": "Tilføj bruger",
  "Are you sure that you want to close this task?": "Er du sikker på, at du vil lukke denne opgave?",
  "Are you sure you want to delete this task type?": "Er du sikker på, at du vil slette denne opgavetype?",
  "Auto-assigned users for %{projectName}": "Auto-tildelte brugere for %{projectName}",
  "Choose profile picture": "Vælg profilbillede",
  "Close task": "Luk opgave",
  "Closing...": "Lukker...",
  "Confirmed": "Bekræftet",
  "Could not find the selection callback": "Valgfunktionen kunne ikke findes",
  "Could not load auto-assigned users": "Kunne ikke indlæse auto-tildelte brugere",
  "Could not load invoices": "Kunne ikke indlæse fakturaer",
  "Could not load profile": "Kunne ikke indlæse profil",
  "Could not read the selected image": "Kunne ikke læse det valgte billede",
  "Could not load project members": "Kunne ikke indlæse projektmedlemmer",
  "Could not load task types": "Kunne ikke indlæse opgavetyper",
  "Could not load user roles": "Kunne ikke indlæse brugerroller",
  "Could not load users": "Kunne ikke indlæse brugere",
  "Delete user role": "Slet brugerrolle",
  "Edit file": "Rediger fil",
  "Edit user role": "Rediger brugerrolle",
  "Forbidden": "Forbudt",
  "General": "Generelt",
  "Invoice group": "Fakturagruppe",
  "Invoice group id is missing": "Fakturagruppe-id mangler",
  "Invoice group was not found": "Fakturagruppen blev ikke fundet",
  "Loading invoices...": "Indlæser fakturaer...",
  "Loading profile...": "Indlæser profil...",
  "Loading task types...": "Indlæser opgavetyper...",
  "Loading tasks...": "Indlæser opgaver...",
  "Loading user roles...": "Indlæser brugerroller...",
  "Loading users...": "Indlæser brugere...",
  "Members for %{projectName}": "Medlemmer for %{projectName}",
  "Add task type": "Tilføj opgavetype",
  "New task type": "Ny opgavetype",
  "No auto-assigned users yet": "Ingen auto-tildelte brugere endnu",
  "No invoices in this group": "Ingen fakturaer i gruppen",
  "No members yet": "Ingen medlemmer endnu",
  "No more users available to add": "Ingen brugere tilbage at tilføje",
  "No open tasks": "Ingen åbne opgaver",
  "No task types found": "Ingen opgavetyper fundet",
  "No users match the current filters": "Ingen brugere matcher filtrene",
  "Owner": "Ejer",
  "Password confirmation": "Bekræft adgangskode",
  "Passwords do not match": "Adgangskoderne stemmer ikke",
  "Please choose an image file": "Vælg venligst en billedfil",
  "Please enter a positive number of hours": "Indtast venligst et positivt antal timer",
  "Price per hour": "Pris pr. time",
  "Price per hour (transport)": "Pris pr. time (transport)",
  "Profile picture": "Profilbillede",
  "Remove": "Fjern",
  "Results": "Resultater",
  "Roles for %{name}": "Roller for %{name}",
  "Select": "Vælg",
  "Select user": "Vælg bruger",
  "Task type": "Opgavetype",
  "Task types": "Opgavetyper",
  "Task types for %{projectName}": "Opgavetyper for %{projectName}",
  "The task type was deleted": "Opgavetypen blev slettet",
  "The task was closed": "Opgaven blev lukket",
  "The user has no roles": "Brugeren har ingen roller",
  "The user role was deleted": "Brugerrollen blev slettet",
  "The user role was saved": "Brugerrollen blev gemt",
  "The work was saved": "Arbejdet blev gemt",
  "Total": "I alt",
  "User added to auto-assignment": "Brugeren blev tilføjet til auto-tildeling",
  "User added to project": "Brugeren blev tilføjet til projektet",
  "User removed from auto-assignment": "Brugeren blev fjernet fra auto-tildeling",
  "User removed from project": "Brugeren blev fjernet fra projektet",
  "User search": "Brugersøgning",
  "User selected": "Bruger valgt",
  "Waiting": "Afventer",
  "You do not have access to this page": "Du har ikke adgang til denne side",
  "You must sign in to continue": "Du skal logge ind for at fortsætte",
  "Your profile": "Din profil",
  "Your profile was saved": "Din profil blev gemt",
  "haya_select.no_options_found": "Ingen muligheder fundet",
  "haya_select.nothing_selected": "Intet valgt",
  "haya_select.pagination_page_of_pages": "Side %{page} af %{totalPages}",
  "haya_select.search_dot_dot_dot": "Søg...",
  "Conflicts": "Konflikter",
  "Database connection timeout": "Tidsudløb for databaseforbindelse",
  "Last synced": "Sidst synkroniseret",
  "Next retry": "Næste forsøg",
  "Next retry %{date}": "Næste forsøg %{date}",
  "No network connection": "Ingen netværksforbindelse",
  "Project sync settings are incomplete": "Projektsynkroniseringsindstillingerne er ufuldstændige",
  "Queued changes": "Ændringer i kø",
  "Reason": "Årsag",
  "Rejected changes": "Afviste ændringer",
  "Sync failed": "Synkronisering mislykkedes",
  "Sync request rejected": "Synkroniseringsanmodning afvist",
  "Sync sign-in required": "Log ind for synkronisering",
  "Sync status": "Synkroniseringsstatus",
  "%{count} changes queued": "%{count} ændringer i kø",
  "%{count} changes rejected": "%{count} ændringer afvist",
  "%{count} conflicts": "%{count} konflikter",
  "%{date} last synced": "Sidst synkroniseret %{date}"
}
